// Separate power meter (pedals, crank, hub): its measurement takes precedence over the trainer's.
import { t } from '../i18n/index.js';
import { BleDevice, valueOf, type GattServer, type StatusFn } from './ble.js';
import { UUID, CyclingPowerParser, type Reading } from './gatt.js';

export class PowerMeter extends BleDevice {
  private parser: CyclingPowerParser;
  constructor(private readonly onData: (d: Reading) => void, onStatus: StatusFn, wheelMm: number) { super(onStatus); this.parser = new CyclingPowerParser(wheelMm); }
  set wheelMm(mm: number) { this.parser.wheelMm = mm; }
  protected fallbackName() { return t.devices.powerMeter; }
  protected filters() { return { filters: [{ services: [UUID.cps] }] }; }
  protected detach() { this.parser.reset(); }
  protected async attach(srv: GattServer) {
    const m = await (await srv.getPrimaryService(UUID.cps)).getCharacteristic(UUID.cpsMeasurement);
    m.addEventListener('characteristicvaluechanged', e => this.onData(this.parser.parse(valueOf(e), performance.now())));
    await m.startNotifications();
  }
}
